import { useState, useEffect, useCallback, useRef } from 'react';
import { getMyCalendar } from '../../services/myCalendarService';

// api.js GET okumalarında REJECT ETMEZ — gerçek sinyal res.data.status (usePersonnelFile deseni).
// Hızlı yıl değiştirmede geç gelen eski yıl yanıtı yeni yılın verisini EZMEZ: her istek bir sıra numarası
// alır, yalnız en son isteğin yanıtı yazılır.
export default function useMyCalendar(year) {
  const [state, setState] = useState({ fetching: true, data: null, error: false });
  const [tick, setTick] = useState(0);
  const lastRequest = useRef(0);

  useEffect(() => {
    const requestId = lastRequest.current + 1;
    lastRequest.current = requestId;
    setState({ fetching: true, data: null, error: false });

    getMyCalendar(year)
      .then((res) => {
        if (requestId !== lastRequest.current) return;
        if (res?.data?.status) setState({ fetching: false, data: res.data.data, error: false });
        else setState({ fetching: false, data: null, error: true });
      })
      .catch(() => {
        if (requestId === lastRequest.current) setState({ fetching: false, data: null, error: true });
      });
  }, [year, tick]);

  const refresh = useCallback(() => setTick((p) => p + 1), []);

  return { ...state, refresh };
}
